import { useParams } from 'react-router-dom';
import React, { Suspense } from 'react';
import { PropertyDetailsLayout } from '@acp/core-ui';

const PropertyDetailsPage = React.lazy(() => import('../features/property-details/page'));

export function PropertyDetails() {
    const params = useParams();
    const propertyId = Number(params.propertyId);

    return (
        <Suspense fallback={<PropertyDetailsLayout.Skeleton />}>
            <PropertyDetailsPage propertyId={propertyId} />
        </Suspense>
    );
}
